module.exports = __webpack_public_path__ + "static/media/Wildschwein.83cd5b27.jpg";